import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RulesetResult } from '../rules';
import { RulesetProxy } from '../ruleset_engine/RulesetProxy';
import { EnumFeatureType } from '../../../../../../../constants';
import {
  getNaturalLoanCategory,
  isOptionalPgNaturalCategory,
} from '../../../../../../../components/loan_application/utils/helpers';

export class PrincipalIsPgRuleset implements Ruleset {
  public evaluate(data: Partial<ApplicationFormValues>): RulesetResult {
    const naturalCategory = getNaturalLoanCategory(
      data as ApplicationFormValues
    );
    // Show when the natural archetype allows an optional PG answer.
    // Do not use remapped loan_category — natural Core OpCo stays hidden.
    if (isOptionalPgNaturalCategory(naturalCategory))
      return RulesetResult.REQUIRED;
    return RulesetResult.HIDDEN;
  }
}

export default new RulesetProxy(new PrincipalIsPgRuleset(), EnumFeatureType.PG);
